//run from current domain
//export const API_URL = 'http://sappsid.roche.com/iaudit/api/v1.0';
//export const EVIDENCE_URL = 'http://sappsid.roche.com/iaudit/evidences';

//run from localhost
//export const API_URL = 'http://localhost/iaudit/api/v1.0';
//export const EVIDENCE_URL = 'http://localhost/iaudit/evidences';

//run from visul studio
//export const API_URL = 'http://localhost:64012/api/v1.0';
//export const EVIDENCE_URL = 'http://localhost:64012/evidences';

export const API_URL = 'https://apiresolve.esatecsolution.com/api/v1.0';
export const EVIDENCE_URL = 'https://apiresolve.esatecsolution.com/evidences';

export const SERVER_DATE_FORMAT = 'LL';
export const DISPLAY_DATE_FORMAT: string = 'dd MMM yyyy';
export const MAT_DISPLAY_DATE_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'DD MMMM YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'DD MMMM YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

